import { render, staticRenderFns } from "./Locations.vue?vue&type=template&id=f2c4d3de&scoped=true&"
import script from "./Locations.vue?vue&type=script&lang=js&"
export * from "./Locations.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2c4d3de",
  null
  
)

export default component.exports